/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Stable Roadmap semantics independent of a node's hierarchy depth.
 */
export enum RoadmapNodeRole {
    SCOPE_ROOT = 'scope_root',
    GROUP = 'group',
    ROADMAP_INITIATIVE = 'roadmap_initiative',
}
